import { render } from "./AppPaletteModal.vue?vue&type=template&id=7c8a3f24&scoped=true&ts=true"
import script from "./AppPaletteModal.vue?vue&type=script&lang=ts"
export * from "./AppPaletteModal.vue?vue&type=script&lang=ts"

import "./AppPaletteModal.vue?vue&type=style&index=0&id=7c8a3f24&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a3f24"]])

export default __exports__